import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { SessionService } from './../services/session.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  apiUrl = environment.apiUrl;

  isLoggedIn = false;
  // store the URL so we can redirect after logging in
  public redirectUrl: string;

  private getTokenUrl = this.apiUrl + '/user/token';
  private _registerUrl = this.apiUrl + '/user/register';
  private _createUrl = this.apiUrl + '/user/create';
  private _loginUrl = this.apiUrl + '/user/login';
  private _username = this.apiUrl + '/user/username_verify';
  private _verifyEmailUrl = this.apiUrl + '/user/email_verify';
  private _resendVerificationEmailUrl = this.apiUrl + '/user/resend_email_verification';
  private _resendEmailPasswordChangeUrl = this.apiUrl + '/user/password_change';
  private _resetVerifyEmailPassword = this.apiUrl + '/user/password_email_verify';
  private _resetPassword = this.apiUrl + '/user/reset_change_password';
  private _currentUser = this.apiUrl + '/user/current';

  private getGoogleAuthUrl = this.apiUrl + '/user/google/url';
  private getGoogleTokenUrl = this.apiUrl + '/user/google/token';

  private getFbAuthUrl = this.apiUrl + '/user/facebook/url';
  private getFbTokenUrl = this.apiUrl + '/user/facebook/token';

  private getTwitterAuthUrl = this.apiUrl + '/user/twitter/url';
  private getTwitterTokenUrl = this.apiUrl + '/user/twitter/token';

  private getLinkedinAuthUrl = this.apiUrl + '/user/linkedin/url';
  private getLinkedinTokenUrl = this.apiUrl + '/user/linkedin/token';

  private getSocialCredentialUrl = this.apiUrl + '/user/social/get';
  private setSocialCredentialUrl = this.apiUrl + '/user/social/create';

  // image upload test
  private _imageUploadUrl = this.apiUrl + '/user/test_aws';

  constructor(private http: HttpClient, private _sessionService: SessionService,
    private _router: Router) { }

  registerUser(user: any): Observable<any> {
    return this.http.post<any>(this._registerUrl, user);
  }

  createUser(user: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` })
    };
    return this.http.post<any>(this._createUrl, user, httpOptions);
  }

  loginUser(user: any): Observable<any> {
    // console.log(user);
    return this.http.post<any>(this._loginUrl, user);
  }

  loggedInUser(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${localStorage.getItem('token')}`
      })
    };
    console.log(httpOptions);
    return this.http.get<any>(this._currentUser, httpOptions);
  }

  verifyCode(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json' ,
                                Authorization: `${localStorage.getItem('token')}`})
    };
    console.log(httpOptions);
    return this.http.get<any>(this._currentUser, httpOptions);
  }

  logoutUser() {
    localStorage.clear();
    this._router.navigate(['auth/employee/login']);
  }

  getToken(code): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        AccessCode: code
      })
    };
    console.log(httpOptions);
    return this.http.get<any>(this.getTokenUrl, httpOptions);
  }

  availableUser(uniqueUser: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.post<any>(this._username, uniqueUser, httpOptions);
  }

  generateGoogleAuthUrl(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.get<any>(this.getGoogleAuthUrl, httpOptions);
  }

  getGoogleToken(code): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`,
        GoogleCallbackCode: code
      })
    };
    return this.http.get<any>(this.getGoogleTokenUrl, httpOptions);
  }

  generateFbAuthUrl(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.get<any>(this.getFbAuthUrl, httpOptions);
  }

  getFbToken(code): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`,
        FacebookCallbackCode: code
      })
    };
    return this.http.get<any>(this.getFbTokenUrl, httpOptions);
  }

  generateTwitterAuthUrl(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.get<any>(this.getTwitterAuthUrl, httpOptions);
  }

  getTwitterToken(oauthverifiercode): Observable<any> {
    const oathCreds = JSON.parse(localStorage.getItem('oauth_credentials'));
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`,
        reqtkn: oathCreds.reqTkn,
        reqtknsecret: oathCreds.reqTknSecret,
        oauthverifier: oauthverifiercode
      })
    };
    return this.http.get<any>(this.getTwitterTokenUrl, httpOptions);
  }

  generateLinkedinAuthUrl(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.get<any>(this.getLinkedinAuthUrl, httpOptions);
  }

  getLinkedinToken(code): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`,
        LinkedinCallbackCode: code
      })
    };
    return this.http.get<any>(this.getLinkedinTokenUrl, httpOptions);
  }

  getSocialCredentails(type: string, platform: string): Observable<any> {
    const getSocialCredentialUrlConst = `${this.getSocialCredentialUrl}/${type}/${platform}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.get<any>(getSocialCredentialUrlConst, httpOptions);
  }

  setSocialCredentials(credentials: any, type: string, platform: string): Observable<any> {
    const data = {
      token: credentials,
      type,
      platform
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`
      })
    };
    return this.http.post<any>(this.setSocialCredentialUrl, data, httpOptions);
  }

  verifyEmail(emailCode: any): Observable<any> {
    return this.http.post<any>(this._verifyEmailUrl, emailCode);
  }

  resendEmailPasswordChange(email: any): Observable<any> {
    return this.http.post<any>(this._resendEmailPasswordChangeUrl, email);
  }

  resetPasswordVerifyEmail(emailCode: any): Observable<any> {
    return this.http.post<any>(this._resetVerifyEmailPassword, emailCode);
  }

  resetPassword(resetPasswordData: any): Observable<any> {
    return this.http.post<any>(this._resetPassword, resetPasswordData);
  }

  resendEmail(email: any): Observable<any> {
    return this.http.post<any>(this._resendVerificationEmailUrl, email);
  }

  imageUpload(image: any): Observable<any> {
    return this.http.post<any>(this._imageUploadUrl, image);
  }

  getCurrentUserAuthenticate() {
    return this.loggedInUser()
      .pipe(
        map(res => {
          console.log(res);
          this._sessionService.setUserFullName(res.f_name + ' ' + res.l_name);
          this._sessionService.setUserName(res.username);
          this._sessionService.setUserType(res.user_type);
          this._sessionService.setUserEmail(res.email);
          this._sessionService.setUserProfileImage(res.profile_image);
          this._sessionService.setUserDesignation(res.designation);
          return true;
        })
      );
  }

}
